import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=a49b621a"
import script from "./InfiniteScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfiniteScroll.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports